export default class Layout
{

   static nodes = {
      doc: document.body,
      header: document.querySelector('.header'),
      burger: document.querySelector('.menu__item--burger'),
      mobileBurgerLinks: document.querySelectorAll('.menu__item-btn, .mobile-menu__item-link, .mobile-menu__item-btn'),
   }

   constructor() {

      Layout.nodes.burger.addEventListener('click',  this.checkMobileMenu);
      this.resizeWindow()
      this.sortItems()
   }

   sortItems() {
      Layout.nodes.mobileBurgerLinks.forEach(item => {
         item.addEventListener('click', this.checkMobileMenu);
      })
   }

   checkMobileMenu() {
      if(window.innerWidth <= 1100) {
         Layout.nodes.doc.classList.contains('mob-menu--active') ? Layout.nodes.doc.classList.remove('mob-menu--active') : Layout.nodes.doc.classList.add('mob-menu--active');
      }
   }

   resizeWindow() {
      addEventListener('resize', (el) => {

         if(window.innerWidth >= 1100) {
            Layout.nodes.doc.classList.remove('mob-menu--active');

         } else if (Layout.nodes.doc.classList.contains('mob-menu--active')) {
            Layout.nodes.doc.classList.add('mob-menu--active');

         } else {
            Layout.nodes.doc.classList.remove('mob-menu--active');
         }
      });
   }
}